export default __webpack_public_path__ + "static/media/location-arrow.85c06361.svg";